// DS: C59
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { useTranslation } from 'react-i18next';
import DesktopSharePopup from './DesktopSharePopup';
import { getDeviationShareCodes } from '../helpers';
import { getTranslatedDeviationTitle, getDeviationResourceType } from '../../DeviationViews/_helpers';
const DesktopDeviationSharePopup = ({ deviation  })=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(DesktopSharePopup, _extends({
        title: getTranslatedDeviationTitle(deviation, t),
        biData: {
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId
        }
    }, getDeviationShareCodes(deviation)));
};
DesktopDeviationSharePopup.displayName = 'DesktopDeviationSharePopup';
export default DesktopDeviationSharePopup;
